import styled from 'styled-components/macro';
import { hideVisually, transparentize } from 'polished';

import colors from 'styles/themes/colors';
import theme from 'styles/themes/variables';

export const Wrapper = styled.div`
  margin-top: ${theme.spacing.medium};
  width: 100%;
`;

export const Fieldset = styled.fieldset<any>`
  border: none;
  padding: 0;
  margin: 0;
  opacity: ${({ fade }): number => (fade ? 0.4 : 1)};
  transition: opacity 80ms linear;
`;

export const Legend = styled.legend`
  ${hideVisually()};
`;

export const Inputs = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;

  @media screen and (min-width: 640px) {
    align-items: center;
    flex-flow: row wrap;
  }
`;

export const Input = styled.input`
  display: none;
`;

export const SVG = styled.svg`
  flex: 0 0 auto;
`;

export const DisplayName = styled.span`
  margin-left: ${theme.spacing.small};
  line-height: 1.2;
  font-weight: 600;
  color: ${colors.DeepBlue};
`;

export const Label = styled.label<any>`
  display: flex;
  align-items: center;
  margin-right: ${theme.spacing.medium};
  padding: ${theme.spacing.xsmall} ${theme.spacing.small};
  background: ${({ color }): string => transparentize(1, color)};

  &:last-of-type {
    margin-right: 0;
  }

  &:hover,
  &:focus {
    background: ${({ color }): string => transparentize(0.9, color)};
  }
`;
